import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../../blocs/AuthLayout";
import * as Yup from "yup";
import {
  registerFailure,
  registerStart,
  registerSuccess,
} from "../../store/slices/userSlice";
import axios from "axios";
import Checkbox from "../../components/inputs/checkbox";
import { toast } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import Divider from "../../components/divider";
import GoogleLoginButton from "../../components/googleBtn";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Helmet, HelmetProvider } from "react-helmet-async";

function RegisterPrestataire() {
  const dispatch = useDispatch();
  const location=useLocation()
  const placeId=location?.state?.placeId
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email invalide") 
    .required("Email Obligatoire"),
   legalAccepted: Yup.boolean()
         .oneOf([true], "Vous devez accepter les conditions générales")
         .required("Vous devez accepter les conditions générales"),
    password: Yup.string()
      .min(8, "Le mot de passe doit contenir au moins 8 caractères")
      .required("Le mot de passe est requis"),
  });
  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    const { email, password, siteAccepted } = values;

    const userData = {
      email,
      password,
      role: "prestataire",
      newsletter: siteAccepted,

    };
     // Add placeId if it exists in values or somewhere else in your state/context
     if (placeId !== null && placeId !== undefined) {
      userData.google_place_id = placeId;
    }

    try {
      dispatch(registerStart()); // Start loading
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}register/add`,
        userData
      );
      dispatch(registerSuccess()); // Success action
      if (response.data?.token) {
        localStorage.clear();
        localStorage.setItem("token", response?.data?.token);
        navigate("/personalInformations", {
          state: { token: response?.data?.token },
        });
      } else {
        toast.error("Une erreur est survenue lors de l'inscription");
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.errors || "Échec de l'inscription";
      dispatch(registerFailure(errorMessage)); // Dispatch failure action
      toast.error(errorMessage);
    }
    setSubmitting(false);
  };

  return (
    <AuthLayout
      image={"../images/Twyny_InscriptionPro.jpg"}
      title="Obtenez des <strong>rendez-vous prévus et réglés à l'avance !</strong>"
    >
       <HelmetProvider>
                        <Helmet>
                          <title>Inscription Prestataire </title>
                          <meta
                            name="description"
                            content="Inscription Prestataire étape email , mot de passe"
                          />
                        </Helmet>
                      </HelmetProvider>
      <GoogleOAuthProvider  
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          redirectUri={window.location.origin}>
      <div className="align-items-start col-md-12 mt-24 pb-16">
        <h3 className="mr-16">
          Inscription <span className="tag-user">Professionnel</span>
        </h3>
        <Formik
          initialValues={{
            email: "",
            password: "",
            legalAccepted: false,
            siteAccepted: false,
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({
            isSubmitting,
            setFieldValue,
            errors,
            values,
            handleChange,
            touched,
          }) => (
            <Form className="register-form">
              {/* Email Field */}
              <div className="input-wrapper">
                <label className="form-label">Email*</label>
                <Field
                  name="email"
                  type="email"
                  className={` ${
                    touched.email && errors.email ? "is-invalid" : ""
                  }`}
                  placeholder="john@gmail.com"
                />
                <ErrorMessage name="email">
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Error"
                      />
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </div>

              {/* Password Field */}
              <div className="input-wrapper password ">
                <label className="form-label">Mot de passe*</label>
                <div className="password-input-wrapper">
                  <Field
                    name="password"
                    type={isVisible ? "text" : "password"} // Toggle between text and password
                    // as={PasswordInput}
                    className={`${
                      touched.password && errors.password ? "is-invalid" : ""
                    }`}
                    placeholder="Mot de passe"
                  />
                  <span
                    className="visibility-toggle"
                    onClick={toggleVisibility}
                  >
                    <img
                      src={
                        isVisible
                          ? "/images/eye-closed.svg"
                          : "/images/eye-open.png"
                      }
                      alt="eye toggle"
                      width={24}
                      height={24}
                    />
                  </span>
                </div>
                <ErrorMessage name="password">
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Arrow"
                      />
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
                {(!touched.password || !errors.password) && (
                  <span className="mt-8 legend grey66">
                    Le mot de passe doit faire plus de 8 caractères
                  </span>
                )}
              </div>

              {/* Legal Checkbox */}
              <div className="form-group ">
                <Field
                  name="legalAccepted"
                  component={Checkbox}
                  id="legal-checkbox"
                  label="En créant mon compte, j'accepte les"
                  links={[
                    { text: "CGV", url: "/cgv" },
                    { text: ", " },
                    { text: "CGU ", url: "/cgu" },
                    { text: " et la " },
                    {
                      text: "Politique de confidentialité",
                      url: "/politique-confidentialite",
                    },
                  ]}
                  onChange={(e) =>
                    setFieldValue("legalAccepted", e.target.checked)
                  }
                  checked={values.legalAccepted || false}
                />
                <ErrorMessage name="legalAccepted">
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Arrow"
                      />
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </div>

              {/* Newsletter Checkbox */}
              <div className="form-group mb-4">
                <Field
                  name="siteAccepted"
                  as={Checkbox}
                  id="site-checkbox"
                  label="J'accepte de recevoir des communications commerciales Twyny"
                  onChange={(e) =>
                    setFieldValue("siteAccepted", e.target.checked)
                  }
                  checked={values.siteAccepted || false}
                />
              </div>

              <button
                type="submit"
                className="twyny-cta-primary"
                disabled={isSubmitting || Object.keys(errors).length > 0}
              >
                Étape Suivante
              </button>
            </Form>
          )}
        </Formik>
     
        <p className="mt-32 body text-start">
          Vous avez déjà un compte ?{" "}
          <Link to="/login" className="body link-blue">
            Connectez-vous ici
          </Link>
        </p>
        <Divider />
          <GoogleLoginButton role={'prestataire'}  />
      </div>
      </GoogleOAuthProvider>
    </AuthLayout>
  );
}

export default RegisterPrestataire;
